var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalling = function SvgCalling(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8287 67.6993C67.8287 56.9769 68.0424 43.1479 67.7876 30.8299M15.7942 67.2844C15.5372 53.5924 15.2803 42.3899 15.2803 26.7617H50.7525",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.422 24.3341C73.1787 41.5607 72.6742 53.826 72.6742 67.8828M11.0639 68.8475C10.6855 53.5503 10.6855 44.0413 10.6855 25.2988C10.6855 23.5073 11.8206 21.8535 13.2079 21.8535L50.7555 21.8535",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3373 11.2039C53.1617 11.314 51.4695 11.4793 51.4695 13.7368C51.4695 15.9943 51.3486 18.01 51.3486 18.6707C51.2278 23.1859 51.3486 23.0029 51.3486 27.833C51.4695 29.4849 52.7991 30.3659 53.5243 30.3659C57.6339 30.8064 65.3695 30.5861 70.5669 30.5861C72.5008 30.5861 72.3843 26.3616 72.3843 23.9388C74.6808 25.5907 77.6982 27.2824 79.8738 28.4937C79.8738 25.7406 80.1156 15.4988 79.8738 14.0672C77.6982 15.1684 74.5556 16.3798 72.1382 17.7013C72.2591 13.5165 72.2591 11.0938 68.2704 11.0938C66.5782 11.0938 60.0512 11.0937 55.3373 11.2039Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8392 67.9531H11.1973",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97168 68.8477C34.0381 69.0641 50.1473 69.0422 78.9337 68.8477V72.5459C78.9337 74.188 77.6102 75.5251 75.9682 75.5449C49.8679 75.8597 34.0248 75.8504 7.9384 75.5439C6.29596 75.5246 4.97168 74.1873 4.97168 72.5448V68.8477Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.1709,
    y: 67.9531,
    width: 22.5575,
    height: 2.96884,
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0296 48.5502C34.0104 43.891 34.3016 39.8143 36.1944 36.9023C38.0871 33.9904 41.2903 32.5344 44.6391 33.1168C46.9686 33.408 49.1526 34.864 50.3174 36.9023C52.5013 41.2703 51.4822 46.803 49.5894 51.1709C48.8614 52.4813 48.1334 53.3549 47.1142 54.2285C42.7463 57.4316 36.34 55.2477 35.0296 48.5502Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3667 56.2672C42.7459 56.5584 40.9988 56.1216 39.834 55.248",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3379 49.1325C51.7747 48.8413 52.2115 48.6957 52.3571 48.4045C52.5027 48.2589 52.5027 48.2589 52.5027 48.1133",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3031 48.5492C34.0119 48.4036 33.8663 48.258 33.7207 47.9668",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7865 50.1523C43.6217 50.7347 42.0202 50.8803 41.001 50.1523",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6611 59.3926C36.0923 60.907 39.2538 62.9721 42.7028 63.1097C46.0081 63.2474 49.457 61.8707 50.463 60.0809",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2524 55.3926C39.2524 56.703 39.1068 57.2854 38.9612 58.7413L37.7964 58.8869C34.0109 60.0517 32.1181 61.0709 30.9533 62.2357C29.7886 63.4005 29.3518 64.4196 28.915 65.4388C28.598 66.284 27.7852 68.8465 27.7852 68.8465M46.6779 55.5382C46.6779 56.703 46.6779 56.5574 46.8235 57.7221L47.1147 59.1781C48.5707 59.6149 50.9003 60.4885 51.9195 60.9253C54.3946 61.9445 55.8506 63.8373 56.1418 65.5844C56.3801 67.0143 56.3801 67.934 56.3801 68.7198",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1064 34.2812C41.5816 37.3388 44.7848 39.9596 49.7351 39.9596",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5322 41.6934C51.6778 45.7701 56.1396 50.5881 57.0132 55.2473C57.45 57.4312 56.4308 59.7608 54.8292 61.0712",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7376 40.6875C34.3009 43.1627 33.4273 45.6378 32.2625 47.6762C30.3697 51.025 28.3313 53.3545 28.9137 57.4313C29.0593 59.0328 29.9329 60.4888 31.0977 61.3624",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6035 32.0977L72.4281 32.0977",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7354 25.9707L49.7354 22.1461",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calling.5a7bf1f1e7e351b2d274181cf1195a30.svg";